import React from "react";
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";

// 用户登录
import Login from "./login/login";
// 用户注册
import Register from "./login/register";
// 用户找回
import Forget from "./login/forget";
//首页
import MiniShop from "./minishop";

import { useTranslation } from "react-i18next";

class Pages extends React.Component {
  state = {
    login_state: false,
  };
  componentDidMount() {}
  componentWillUnmount() {
    const { t } = useTranslation();

    document.title = t("WEBTitle");
    this.setState = () => false;
  }
  render() {
    return (
      <div className="full">
        <Router>
          <Switch>
            {/* 首页 */}
            <Route path="/" exact component={MiniShop} />
            <Route path="/index" component={MiniShop} />

            {/* 用户登录注册 */}
            <Route path="/login" component={Login} />
            <Route path="/register" component={Register} />
            <Route path="/forget" component={Forget} />
            <Redirect to={`/login`} />
          </Switch>
        </Router>
      </div>
    );
  }
}
export default Pages;
